module.exports = require('./helpers/bundle-url').getBundleURL('6e9Bk') + "logo.7718c6df.svg";